import styled from "styled-components";
import { Modal } from "../AddClinicians/style";
import { globalColor, globalFont } from "../../utils/RepeatFunctions/Schedule";

export const Div = styled.div`
  display: ${(p) => p.display && p.display};
  padding: ${(p) => p.padding && p.padding};
  border-bottom: ${(p) => p.borderbottom && p.borderbottom};
  margin: ${(p) => p.margin && p.margin};
  text-align: ${(p) => p.align && p.align};
  position: ${(p) => p.position && p.position};
  top: ${(p) => p.top && p.top};
`;
export const H3 = styled.h3`
  margin-left: 0px;
  font-weight: 400;
  font-size: 14px;
  font-family: ${globalFont};
  color: rgb(113, 128, 150);
  line-height: 16.94px;
  text-align: left;
  width: 200px;
  display: flex;
  align-items: flex-end;
`;

export const Input = styled.input`
  border: 1px solid #ced4da;
  border-radius: 4px;
  width: 290px;
  height: 34px;
  outline: none;
  padding: 0px 10px;
`;
export const InputSchedule = styled.textarea`
  border: 1px solid #ced4da;
  border-radius: 4px;
  width: ${(p) => p.width && p.width};
  height: 56px;
  outline: none;
  padding: 0px 10px;
`;


export const Button = styled.button`
  background-color: ${globalColor};
  border-radius: 4px;
  height: 32px;
  color: #ffffff;
  padding: 8px 20px;
  font-size: 17px;
  border: transparent;
  font-weight: 500;
  line-height: 17px;
  height: 34px;
  &.save_active:active {
    background-color: rgba(44, 123, 229, 0.75);
  }
  &.save_active:disabled {
    background-color: rgba(44, 123, 229, 0.5);
    cursor: not-allowed;

  &:hover {
    background-color: ${(p) => p.hoverBackColor && p.hoverBackColor};
  }
`;

export const Select = styled.select`
  border: 1px solid #c3c3df;
  height: 34px;
  width: 290px;
  border-radius: 4px;
  outline: none;
  padding: 0px 10px;
`;
export const Option = styled.option``;

export const ModalShow = styled(Modal)`
  color: #155724;
  background-color: rgba(0, 0, 0, 0.25);
  border-color: #c3e6cb;
  z-index: ${(p) => p.zIndex && p.zIndex};
`;
export const ModalCont = styled(Div)`
  background-color: #d4edda;
  width: 300px;
  height: 65px;
  padding: 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  svg {
    font-size: 30px;
    padding-right: 5px;
  }
`;
